import { METER_IDENTIFIER_KINDS } from '@/shared/meter-identification';
import { OCR_CANDIDATE_FIELDS } from '@/shared/ocr/ocr-candidates';

export const VALUE_SCAN_PURPOSES = {
  apiKey: OCR_CANDIDATE_FIELDS.apiKey,
  devEui: METER_IDENTIFIER_KINDS.devEui,
  meterLookup: 'meter_lookup',
  registerCounter: OCR_CANDIDATE_FIELDS.registerCounter,
  registerObis: OCR_CANDIDATE_FIELDS.registerObis,
  registerUnit: OCR_CANDIDATE_FIELDS.registerUnit,
  serial: OCR_CANDIDATE_FIELDS.serial,
} as const;

export type ValueScanPurpose = (typeof VALUE_SCAN_PURPOSES)[keyof typeof VALUE_SCAN_PURPOSES];
